import { createBuilderModule } from '../../../register-builder/builder-module';
import { withTracking, SectionName } from '../../../observability';
import { COLOR_KEYS } from '../../../constants';
import { DEFAULT_VALUES } from './fixtures';
import { ResourcesSection } from './ResourcesSection';

export default createBuilderModule(
  withTracking(ResourcesSection, {
    as: 'section',
    sectionName: SectionName.ResourcesSection,
  }),
  {
    name: 'ResourcesSection',
    image: 'https://cdn.zappy.app/4facc3abf377333bfae6f9585e51e76c.png',
    inputs: [
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroundColor,
      },
      {
        name: 'heading',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.heading,
      },
      {
        name: 'groups',
        type: 'list',
        required: true,
        defaultValue: DEFAULT_VALUES.groups,
        subFields: [
          {
            name: 'heading',
            type: 'string',
            required: true,
          },
          {
            name: 'description',
            type: 'richText',
            required: true,
          },
          {
            name: 'links',
            type: 'list',
            required: true,
            subFields: [
              {
                name: 'text',
                type: 'string',
                required: true,
              },
              {
                name: 'url',
                type: 'string',
                required: true,
              },
              {
                name: 'showRating',
                type: 'boolean',
              },
            ],
          },
        ],
      },
    ],
  },
);
